// @ts-nocheck
import React, { useState, useRef } from "react";
import Typography from "@mui/material/Typography";
import { renderToString } from "react-dom/server";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { textColor } from "../../utils/commonstyle";
import { Box, CircularProgress, Grid2, TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useMsal } from "@azure/msal-react";
import moment from "moment";
import momenttimezone from "moment-timezone";
import CustomTextField from "../commonComponents/TextFieldComponent";
import ButtonComponents from "../commonComponents/ButtonComponents";
import {
  remoteBidding,
  bidderAgreement,
  bidderAgreementData,
} from "./agreementData";
import { getTermsUpdate } from "../../redux/slice/userSlice";
import html2pdf from "html2pdf.js";
import PDFComponent from "./PDFComponent";
import { getIsWiredTransfer } from "../../utils/config";

const BiddingAgreement = () => {
  const contentRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { instance } = useMsal();
  const [pdfLoading, setPdfLoading] = useState(false);
  const { responseData, bussinessUserdata, loading, loginUserDetails, loginInvestorId } =
    useSelector((state) => state.user);
  const userName =
    loginUserDetails?.UserType === "individual"
      ? loginUserDetails?.ProfileName || `${loginUserDetails.FirstName} ${loginUserDetails.LastName}`
      : loginUserDetails?.BusinessDetailsResponse?.BusinessName || loginUserDetails?.UserName;
  const [state, setState] = useState({
    masterTitle: "",
    biddingTitle: "",
    masterTime: "",
    biddingTime: "",
  });
  const [masterShow, setMasterShow] = useState(false);
  const [biddingShow, setBiddingShow] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const pdfResonse = await generatePDF();
  };

  const handleMasterRemote = (event, type) => {
    const nowUTC = momenttimezone.utc();
    // Convert the UTC time to CST (Central Standard Time)
    const cstTime = nowUTC.clone().tz("America/Chicago");
    if (type === "master") {
      setMasterShow(true);
      setState((prevState) => ({
        ...prevState,
        masterTime: cstTime,
      }));
    } else {
      setBiddingShow(true);
      setState((prevState) => ({
        ...prevState,
        biddingTime: cstTime,
      }));
    }
  };

  const sendBase64ToServer = async (formData) => {
    const payload = {
      email: loginUserDetails?.Email,
      investorId: loginInvestorId,
      signedBiddingAggrement: formData,
    };
    const response = await dispatch(getTermsUpdate(payload)).unwrap();
    setPdfLoading(false);
    if (response.ok) {
      if (getIsWiredTransfer() === "1") {
        navigate("/kyc-kyb/account-verification/add-funds-wired-transfer");
      } else {
        navigate("/kyc-kyb/account-verification/add-bank-account");
      }
    }
  };

  const generatePDF = async () => {
    const element = contentRef.current;
    try {
      setPdfLoading(true);
      const htmlString = renderToString(
        <PDFComponent
          ref={contentRef}
          responseData={loginUserDetails}
          username={userName}
          state={state}
          bussinessUserdata={bussinessUserdata}
        />
      );
      const base64Html = btoa(unescape(encodeURIComponent(htmlString)));

      const formData = new FormData();

      formData.append("SignedBiddingAggrement", base64Html); // file field name
      await sendBase64ToServer(base64Html);
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };

  return (
    <Box
      width={{ md: "100%", sm: "70%" }}
      className="flex flex-col flex-1  mt-3 bg-white mx-auto p-4"
      sx={{ boxShadow: "0px 0px 6px 0px #3B3B3B26", alignItems: "center" }}
      data-testid="bidding-agreement-container"
    >
      <Box
        sx={{
          mb: 2,
          p: 3,
          width: "100%",
          margin: "auto",
          display: "block",
          justifyContent: "center",
          boxShadow: "0px 0px 6px 0px #3B3B3B26", // Standard shadow
          borderRadius: "8px", // Rounded corners
          "&:before": { display: "none" }, // Remove default divider line
        }}
        data-testid="master-remote-bidding"
      >
        <Box display={"flex"} width={"100%"} justifyContent={"space-between"}>
          <Typography fontSize={18} data-testid="master-remote-bidding-title">
            Master Remote Bidding Agreement
          </Typography>
          <ButtonComponents
            label={"Sign Agreement"}
            sx={{ fontSize: 14 }}
            onClick={() => {
              const element = document.getElementById("master-sign-aggrement");
              if (element) {
                element.scrollIntoView({
                  behavior: "smooth", // Smooth scrolling
                  block: "start", // Align to the top of the viewport
                });
              }
            }}
          />
        </Box>
        <Typography variant="body1" color="initial">
          Agreement Terms
        </Typography>
        <Box display={"flex"} my={1} mt={2}>
          <Box border={"1px solid #C5C9CD"} width={{md:"30%", sx:"50%"}} py={"6px"} px={2}>
            <Box color={"#00000061"} fontWeight={400} fontSize={14}>
              Bidder Name
            </Box>
            <Box color={"#00000061"} fontWeight={600} fontSize={17} pt={"4px"}>
            {userName || ''}
            </Box>
          </Box>
          <Box border={"1px solid #C5C9CD"} width={{md:"30%", sx:"50%"}} py={"6px"} px={2}>
            <Box color={"#00000061"} fontWeight={400} fontSize={14}>
              Escrow Agent
            </Box>
            <Box color={"#00000061"} fontWeight={600} fontSize={17} pt={"4px"}>
              Insight Title & Escrow
            </Box>
          </Box>
        </Box>
        {remoteBidding()}
        <Box display={"flex"} width={"100%"} px={"20px"} my={2}>
          <Box width={"30%"}>
            <Typography fontSize={16} mb={3} color={textColor.fontColor}>
              Xome Inc.
            </Typography>
            <Box>
              <Typography fontSize={16} color={textColor.fontColor}>
                Michael Jansta
              </Typography>
              <Typography fontSize={14} color={textColor.fontColor}>
                Chief Operations Officer - Xome
              </Typography>
              <Box
                fontSize={30}
                sx={{ fontFamily: "Great Vibes, serif !important" }}
              >
                Michael Jansta
              </Box>
            </Box>
          </Box>
          <Box
            id="master-sign-aggrement"
            width={"50%"}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <Typography fontSize={16} mb={3} color={textColor.fontColor}>
              {loginUserDetails?.UserType === "individual"
                ? "Bidder"
                : bussinessUserdata?.BusinessName}
            </Typography>
            <Box>
              <Typography fontSize={16} color={textColor.fontColor}>
                {userName}
              </Typography>

              {masterShow ? (
                <>
                  <Typography fontSize={14} color={textColor.fontColor}>
                    {state.masterTitle}
                  </Typography>
                  <Box
                    width={500}
                    display={{ xs: "block", md: "flex" }}
                    justifyContent={"space-between"}
                  >
                    <Box
                      fontSize={30}
                      sx={{ fontFamily: "Great Vibes, serif !important" }}
                    >
                      {userName}
                    </Box>
                  </Box>
                  <Box display={"flex"} justifyContent={"start"}>
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      fontSize={12}
                      color={textColor.fontColor}
                    >
                      {moment(state.masterTime).format("MMM D, YYYY, h:mm A")}{" "}
                      (CST) {/* Added space here */}
                    </Box>
                    <ButtonComponents
                      sx={{
                        fontSize: "14px",
                        bgcolor: "transparent",
                        color: textColor.primaryColor,
                        border: "none",
                        textDecoration: "underline",
                        "&:hover": {
                          fontSize: "14px",
                          bgcolor: "transparent",
                          color: textColor.primaryColor,
                          border: "none",
                          textDecoration: "underline",
                        },
                      }}
                      label={"Undo"}
                      variant="text"
                      onClick={() => {
                        setState((prevState) => ({
                          ...prevState,
                          masterTitle: "",
                          masterTime: "",
                        }));
                        setMasterShow(false);
                      }}
                    />
                  </Box>
                </>
              ) : (
                <Box width={"100%"} display={"flex"}>
                  <Box width={"60%"}>
                    <Grid2 container spacing={1} alignItems="center" my={1}>
                      <Grid2 item xs={8} sx={{ flex: 1 }}>
                        <TextField
                          id="outlined-basic"
                          label="Title"
                          name="title"
                          value={state.masterTitle}
                          variant="outlined"
                          sx={{
                            width: "100%", // Ensure it fills the 8/12 container
                            "& label": {
                              fontSize: "16.75px",
                              // color: `${textColor.primaryColor} !important`,
                            },
                            "& .MuiInputBase-root fieldset": {
                              border: `1px solid ${textColor.primaryColor}`,
                            },
                            "& .MuiInputBase-root": {
                              fontSize: "16px", // Increased font size of the input text by 25%
                            },
                            "& .MuiInputBase-root input": {
                              padding: "16px 14px", // Increased padding for a larger input
                            },
                          }}
                          onChange={(event) => {
                            setState((prevState) => ({
                              ...prevState,
                              masterTitle: event.target.value,
                              biddingTitle: event.target.value,
                            }));
                          }}
                          data-testid="bidder-name-field"
                        />
                        <Typography
                          fontSize={12}
                          my={"2px"}
                          mt={1}
                          color="#3B3B3B"
                        >
                          Please enter your title in your company/entity or
                          "Self" if you plan to bid as an individual
                        </Typography>
                      </Grid2>
                    </Grid2>
                    <Grid2 container spacing={1} alignItems="center" my={1}>
                      <Grid2 item xs={8} sx={{ flex: 1 }}>
                        <TextField
                          id="outlined-basic"
                          label="Your signature will appear here"
                          name="signature"
                          variant="outlined"
                          readOnly
                          disabled
                          sx={{
                            width: "100%", // Ensure it fills the 70% container
                            "& .Mui-disabled": {
                              border: `1px solid ${textColor.fontColor}`,
                            },
                            "&.MuiFormLabel-root input, .MuiFormLabel-root": {
                              border: "none",
                            },
                            "& label": {
                              fontSize: "16.75px",
                              // color: `${textColor.primaryColor} !important`,
                            },
                            "& .MuiInputBase-root": {
                              fontSize: "16px",
                              color: `${textColor.primaryColor} !important`,
                            },
                            "& .MuiInputBase-root input": {
                              padding: "16px 14px",
                              border: "none",
                            },
                            "& .MuiInputBase-root fieldset": {
                              border: "none",
                            },
                          }}
                          onChange={(event) => {
                            setState((prevState) => ({
                              ...prevState,
                              masterTitle: event.target.value,
                            }));
                          }}
                          data-testid="bidder-signature-field"
                        />
                      </Grid2>
                    </Grid2>
                  </Box>

                  <Box
                    display={"block"}
                    marginTop={"auto"}
                    marginBottom={"15px"}
                  >
                    <ButtonComponents
                      label="Sign here"
                      disabled={!state.masterTitle}
                      onClick={(event) => handleMasterRemote(event, "master")}
                      sx={{
                        fontSize: "14px",
                        height: "40px",
                        my: "auto",
                        px: 2,
                      }}
                      data-testid="no-button"
                    />
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
        <Box px={"20px"}>
          <Typography fontSize={14} color={textColor.fontColor}>
            750 State Highway 121 BPY, Ste 100
          </Typography>
          <Typography fontSize={14} color={textColor.fontColor}>
            Lewisville, TX 75067
          </Typography>
          <Typography fontSize={14} color={textColor.fontColor}>
            Attn:
          </Typography>
          <Typography fontSize={14} color={textColor.fontColor}>
            @xome.com
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          my: 3,
          p: 3,
          mx: "auto",
          width: "100%",
          display: "block",
          justifyContent: "center",
          boxShadow: "0px 0px 6px 0px #3B3B3B26", // Standard shadow
          borderRadius: "8px", // Rounded corners
          "&:before": { display: "none" }, // Remove default divider line
        }}
        data-testid="bidding-agreement"
      >
        <Box
          display={"flex"}
          mb={2}
          width={"100%"}
          justifyContent={"space-between"}
        >
          <Typography fontSize={18} data-testid="master-remote-bidding-title">
            Bidding Agreement
          </Typography>
          <ButtonComponents
            label={"Sign Agreement"}
            sx={{ fontSize: 14 }}
            onClick={() => {
              const element = document.getElementById("bidding-aggrement");
              if (element) {
                element.scrollIntoView({
                  behavior: "smooth", // Smooth scrolling
                  block: "start", // Align to the top of the viewport
                });
              }
            }}
          />
        </Box>
        {bidderAgreement()}
        <Typography fontSize={16} mt={"8px"} color={textColor.fontColor}>
          Parties
        </Typography>
        <Typography fontSize={16} mt={"8px"} color={textColor.fontColor}>
          (a) Bidder
        </Typography>
        <Box display={"flex"} justifyContent={"space-between"} mt={1}>
          <Box border={"1px solid #C5C9CD"} width={"100%"} py={"6px"} px={2}>
            <Box color={"#00000061"} fontWeight={400} fontSize={14}>
              Address
            </Box>
            <Box color={"#00000061"} fontWeight={600} fontSize={17} pt={"4px"}>
              {loginUserDetails?.DeliveryLine || ""}
            </Box>
          </Box>
          <Box border={"1px solid #C5C9CD"} width={"100%"} py={"6px"} px={2}>
            <Box color={"#00000061"} fontWeight={400} fontSize={14}>
              City
            </Box>
            <Box color={"#00000061"} fontWeight={600} fontSize={17} pt={"4px"}>
              {loginUserDetails?.City || ""}
            </Box>
          </Box>
          <Box border={"1px solid #C5C9CD"} width={"100%"} py={"6px"} px={2}>
            <Box color={"#00000061"} fontWeight={400} fontSize={14}>
              State
            </Box>
            <Box color={"#00000061"} fontWeight={600} fontSize={17} pt={"4px"}>
              {loginUserDetails?.State || ""}
            </Box>
          </Box>
        </Box>
        <Box display={{ xs: "block", md: "flex" }}>
          <Box border={"1px solid #C5C9CD"} width={"100%"} py={"6px"} px={2}>
            <Box color={"#00000061"} fontWeight={400} fontSize={14}>
              Zip Code
            </Box>
            <Box color={"#00000061"} fontWeight={600} fontSize={17} pt={"4px"}>
              {loginUserDetails?.ZipCode || ""}
            </Box>
          </Box>
          <Box border={"1px solid #C5C9CD"} width={"100%"} pt={"6px"} px={2}>
            <Box color={"#00000061"} fontWeight={400} fontSize={14}>
              Mobile Number
            </Box>
            <Box color={"#00000061"} fontWeight={600} fontSize={17} pt={"4px"}>
              {loginUserDetails?.Phone || ""}
            </Box>
          </Box>
          <Box border={"1px solid #C5C9CD"} width={"100%"} pt={"6px"} px={2}>
            <Box color={"#00000061"} fontWeight={400} fontSize={14}>
              Email Address
            </Box>
            <Box color={"#00000061"} fontWeight={600} fontSize={17} pt={"4px"}>
              {loginUserDetails?.Email || ""}
            </Box>
          </Box>
        </Box>
        <Typography fontSize={16} mt={"8px"} color={textColor.fontColor}>
          (b) Xome
        </Typography>
        <Box display={"flex"} justifyContent={"space-between"} mt={1}>
          <Box border={"1px solid #C5C9CD"} width={"100%"} py={"6px"} px={1.7}>
            <Box color={"#00000061"} fontWeight={400} fontSize={14}>
              Attn.
            </Box>
            <Box color={"#00000061"} fontWeight={600} fontSize={17} pt={"4px"}>
              Michael Jansta
            </Box>
          </Box>
          <Box border={"1px solid #C5C9CD"} width={"100%"} py={"6px"} px={1.7}>
            <Box color={"#00000061"} fontWeight={400} fontSize={14}>
              Address
            </Box>
            <Box color={"#00000061"} fontWeight={600} fontSize={17} pt={"4px"}>
              750 State Highway 121 BPY, Ste 100 Lewisville, TX 75067
            </Box>
          </Box>
          <Box border={"1px solid #C5C9CD"} width={"100%"} pt={"6px"} px={2}>
            <Box color={"#00000061"} fontWeight={400} fontSize={14}>
              Mobile Number
            </Box>
            <Box color={"#00000061"} fontWeight={600} fontSize={17} pt={"4px"}>
              469-293-1272
            </Box>
          </Box>
        </Box>
        <Box display={"flex"} justifyContent={"space-between"}>
          <Box border={"1px solid #C5C9CD"} width={"96%"} py={"6px"} px={1.7}>
            <Box color={"#00000061"} fontWeight={400} fontSize={14}>
              Email Address
            </Box>
            <Box color={"#00000061"} fontWeight={600} fontSize={17} pt={"4px"}>
              jansta@xome.com
            </Box>
          </Box>
          <Box
            border={"1px solid #C5C9CD"}
            borderRight={"none"}
            width={"100%"}
            pt={2}
          ></Box>
          <Box
            border={"1px solid #C5C9CD"}
            borderLeft={"none"}
            width={"100%"}
            pt={2}
          ></Box>
        </Box>
        <Typography fontSize={16} mt={"8px"} color={textColor.fontColor}>
          (c) Escrow Agent
        </Typography>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          mt={1}
          mb={"4px"}
        >
          <Box border={"1px solid #C5C9CD"} width={"100%"} pt={"6px"} px={2}>
            <Box color={"#00000061"} fontWeight={400} fontSize={14}>
              Address
            </Box>
            <Box color={"#00000061"} fontWeight={600} fontSize={17} pt={"4px"}>
              20600 Chagrin Blvd, Suite 1111 Shaker Heights, <br /> OH
              44122-5342
            </Box>
          </Box>
          <Box border={"1px solid #C5C9CD"} width={"100%"} pt={"6px"} px={2}>
            <Box color={"#00000061"} fontWeight={400} fontSize={14}>
              Mobile Number
            </Box>
            <Box color={"#00000061"} fontWeight={600} fontSize={17} pt={"4px"}>
              (703) 659-8772
            </Box>
          </Box>
          <Box border={"1px solid #C5C9CD"} width={"100%"} pt={"6px"} px={2}>
            <Box color={"#00000061"} fontWeight={400} fontSize={14}>
              Email address
            </Box>
            <Box color={"#00000061"} fontWeight={600} fontSize={17} pt={"4px"}>
              drogers@insight-title.com
            </Box>
          </Box>
        </Box>
        <Box sx={{ fontSize: 14 }}>{bidderAgreementData()}</Box>
        <Typography variant="body1" color="initial" mt={2}>
          <strong>IN WITNESS WHEREOF</strong>, the parties hereto have caused
          this Bidder Agreement to be executed.
        </Typography>
        <Box display={{ xs: "block", md: "flex" }} px="20px" my={2}>
          <Box width={{ xs: "100%", md: "30%" }}>
            <Typography fontSize={16} mb={3} color={textColor.fontColor}>
              Xome Inc.
            </Typography>
            <Box>
              <Typography
                fontSize={16}
                fontWeight={600}
                color={textColor.fontColor}
              >
                Michael Jansta
              </Typography>
              <Typography fontSize={14} color={textColor.fontColor}>
                Chief Operations Officer - Xome
              </Typography>

              <Box
                fontSize={30}
                sx={{ fontFamily: "Great Vibes, serif !important" }}
              >
                Michael Jansta
              </Box>
            </Box>
          </Box>
          <Box width={{ xs: "100%", md: "30%" }}>
            <Typography fontSize={16} mb={3} color={textColor.fontColor}>
              Escrow Agent
            </Typography>
            <Box>
              <Typography
                fontSize={16}
                fontWeight={600}
                color={textColor.fontColor}
              >
                Dean Rogers
              </Typography>
              <Typography fontSize={14} color={textColor.fontColor}>
                Specialty Escrow Manager
              </Typography>
              <Box
                fontSize={30}
                sx={{ fontFamily: "Great Vibes, serif !important" }}
              >
                Dean Rogers
              </Box>
            </Box>
          </Box>
          <Box
            width={{ xs: "100%", md: "30%" }}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <Typography fontSize={16} mb={3} color={textColor.fontColor}>
              {loginUserDetails?.UserType === "individual"
                ? "Bidder"
                : bussinessUserdata?.BusinessName}
            </Typography>

            <Box id="bidding-aggrement">
              <Typography
                fontSize={16}
                fontWeight={600}
                color={textColor.fontColor}
              >
                {userName}
              </Typography>

              {biddingShow ? (
                <>
                  <Typography fontSize={14} color={textColor.fontColor}>
                    {state.biddingTitle}
                  </Typography>
                  <Box
                    width={500}
                    display={{ xs: "block", md: "flex" }}
                    justifyContent={"space-between"}
                  >
                    <Box
                      fontSize={30}
                      sx={{ fontFamily: "Great Vibes, serif !important" }}
                    >
                      {userName}
                    </Box>
                  </Box>
                  <Box display={"flex"} justifyContent={"start"}>
                    <Box
                      display={"flex"}
                      alignItems={"center"}
                      fontSize={12}
                      color={textColor.fontColor}
                    >
                      {moment(state.masterTime).format("MMM D, YYYY, h:mm A")}{" "}
                      (CST) {/* Added space here */}
                    </Box>
                    <ButtonComponents
                      sx={{
                        fontSize: "14px",
                        bgcolor: "transparent",
                        color: textColor.primaryColor,
                        border: "none",
                        textDecoration: "underline",
                        "&:hover": {
                          fontSize: "14px",
                          bgcolor: "transparent",
                          color: textColor.primaryColor,
                          border: "none",
                          textDecoration: "underline",
                        },
                      }}
                      label={"Undo"}
                      variant="text"
                      onClick={() => {
                        setState((prevState) => ({
                          ...prevState,
                          biddingTitle: "",
                          biddingTime: "",
                        }));
                        setBiddingShow(false);
                      }}
                    />
                  </Box>
                </>
              ) : (
                <Box width={"100%"} display={"flex"}>
                  <Box width={"70%"}>
                    <Grid2 container spacing={1} my={1}>
                      <Grid2 item size={8} sx={{ flex: 1 }}>
                        <TextField
                          id="outlined-basic"
                          label="Title"
                          name="title"
                          value={state.biddingTitle}
                          variant="outlined"
                          sx={{
                            width: "100%", // Ensure it fills the 8/12 container
                            "& label": {
                              fontSize: "16.75px",
                              // color: `${textColor.primaryColor} !important`,
                            },
                            "& .MuiInputBase-root fieldset": {
                              border: `1px solid ${textColor.primaryColor}`,
                            },
                            "& .MuiInputBase-root": {
                              fontSize: "16px", // Increased font size of the input text by 25%
                            },
                            "& .MuiInputBase-root input": {
                              padding: "16px 14px", // Increased padding for a larger input
                            },
                          }}
                          onChange={(event) => {
                            event.preventDefault();
                            setState((prevState) => ({
                              ...prevState,
                              biddingTitle: event.target.value,
                            }));
                          }}
                          data-testid="bidder-name-field"
                        />
                        <Typography
                          fontSize={12}
                          my={"2px"}
                          mt={1}
                          color="#3B3B3B"
                        >
                          Please enter your title in your company/entity or
                          "Self" if you plan to bid as an individual.
                        </Typography>
                      </Grid2>
                      {/* <Grid2 item xs={2} sx={{ flex: 1 }}></Grid2> */}
                    </Grid2>
                    <Grid2 container spacing={1} alignItems="center" my={1}>
                      <Grid2 size={10} sx={{ flex: 1 }}>
                        <TextField
                          id="outlined-basic"
                          label="Your signature will appear here"
                          name="signature"
                          variant="outlined"
                          readOnly
                          disabled
                          sx={{
                            width: "100% !important", // Ensure it fills the 70% container
                            "& .Mui-disabled": {
                              border: `1px solid ${textColor.fontColor}`,
                            },
                            "&.MuiFormLabel-root input, .MuiFormLabel-root": {
                              border: "none",
                            },
                            "& label": {
                              fontSize: "16.75px",
                              // color: `${textColor.primaryColor} !important`,
                            },
                            "& .MuiInputBase-root": {
                              fontSize: "16px",
                              color: `${textColor.primaryColor} !important`,
                            },
                            "& .MuiInputBase-root input": {
                              padding: "16px 14px",
                              border: "none",
                            },
                            "& .MuiInputBase-root fieldset": {
                              border: "none",
                            },
                          }}
                          data-testid="bidder-signature-field"
                        />
                      </Grid2>
                    </Grid2>
                  </Box>
                  <Box
                    display={"block"}
                    marginTop={"auto"}
                    marginBottom={"15px"}
                  >
                    <ButtonComponents
                      label="Sign here"
                      disabled={!state.biddingTitle}
                      onClick={(event) => handleMasterRemote(event, "bidding")}
                      sx={{
                        fontSize: "14px",
                        height: "40px",
                        my: "auto",
                        px: 2,
                        ml: 2, // Add some margin to separate button from the signature field
                      }}
                      data-testid="no-button"
                    />
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>

      <div className="text-center mt-4" data-testid="submit-button-container">
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#FF5C39",
            px: pdfLoading ? 5 : 2,
          }}
          onClick={handleSubmit}
          disabled={!(masterShow && biddingShow) || pdfLoading}
          data-testid="submit-button"
        >
          {pdfLoading ? (
            <CircularProgress size={25} color="warning" />
          ) : (
            "Proceed"
          )}
        </Button>
      </div>

      {/* PDF */}
      {/* <div className="hidden">
        <PDFComponent ref={contentRef} loginUserDetails={loginUserDetails} username={userName} state={state} bussinessUserdata={bussinessUserdata} />
      </div> */}
    </Box>
  );
};

export default BiddingAgreement;
